module.exports = __webpack_public_path__ + "img/japanese-“open-for-business”-button.8b3720b7.png";